import { GRAPHQL_GET_ONBOARDING_QUESTIONS_SUCCESS } from 'stash/actions/apolloGraphql';

const onboarding_questions = (state = {}, action) => {
	switch (action.type) {
		case GRAPHQL_GET_ONBOARDING_QUESTIONS_SUCCESS: {
			const questionsRaw = action.response.response.questions;
			const order = questionsRaw.map((question) => question.key);
			const questions = questionsRaw.reduce((acc, question) => {
				return {
					...acc,
					[question.key]: question,
				};
			}, {});

			return {
				...state,
				...action.response.response,
				questions,
				order,
			};
		}

		default:
			return state;
	}
};

export default onboarding_questions;
